import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import ListaRevendasView from '@/views/revenda/ListaRevendasView.vue'
import RevendaDetalhesView from '@/views/revenda/RevendaDetalhesView.vue'
import MapaRevendaView from '@/views/revenda/MapaRevendaView.vue'
import HistoricoMapasRevendaView from '@/views/revenda/HistoricoMapasRevendaView.vue'
import ListaRevendasmMapaView from '@/views/revenda/ListaRevendasmMapaView.vue'
import RevendasVitrineView from '@/views/gestao-revendas/RevendasVitrineView.vue'
import AvaliacaoPlayStoreView from '@/views/avaliacaoPlayStore/AvaliacaoPlayStoreView.vue'
import PedidosEntreguesView from '@/views/gestao-revendas/PedidosEntreguesView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: '/revendas',
      name: 'revendas',
      component: ListaRevendasView,
      meta: {
        requiresAuth: true,
        title: 'Lista de Revendas',
        nome_fisico: 'gestao-revendas',
      },
    },
    {
      path: '/revendas/:id',
      name: 'revenda-detalhes',
      component: RevendaDetalhesView,
      meta: {
        requiresAuth: true,
        title: 'Detalhes da Revenda',
        nome_fisico: 'gestao-revendas',
      },
    },
    {
      path: '/revendas/:id/mapa',
      name: 'revenda-mapa',
      component: MapaRevendaView,
      meta: {
        requiresAuth: true,
        title: 'Área de Atuação da Revenda',
      },
    },
    {
      path: '/historico-mapas-revendas',
      name: 'historico-mapas-revendas',
      component: HistoricoMapasRevendaView,
      meta: {
        requiresAuth: true,
        title: 'Histórico de Mapas',
        nome_fisico: 'mudanca-no-mapa-log',
      },
    },

    {
      path: '/revendas-mapa',
      name: 'revendas-mapa',
      component: ListaRevendasmMapaView,
      meta: {
        requiresAuth: true,
        title: 'Revendas no Mapa',
        nome_fisico: 'revendas-mapa',
      },
    },

    {
      path: '/revendas/metricas',
      name: 'revendas-metricas',
      component: RevendasVitrineView,
      meta: {
        requiresAuth: true,
        title: 'Revendas na Vitrine',
        nome_fisico: 'revendas-na-vitrine',
      },
    },

    {
      path: '/avaliacao-play-store',
      name: 'avaliacao-play-store',
      component: AvaliacaoPlayStoreView,
      meta: {
        requiresAuth: true,
        title: 'Avaliações Play Store',
        nome_fisico: 'avaliacao-play-store',
      },
    },

    {
      path: '/pedidos-entregues',
      name: 'pedidos-entregues',
      component: PedidosEntreguesView,
      meta: {
        requiresAuth: true,
        title: 'Pedidos Entregues',
        nome_fisico: 'pedidos-entregues',
      },
    },
  ],
}
